import { render, staticRenderFns } from "./MlbBlog.vue?vue&type=template&id=f378a082&scoped=true"
import script from "./MlbBlog.vue?vue&type=script&lang=js"
export * from "./MlbBlog.vue?vue&type=script&lang=js"
import style0 from "./MlbBlog.vue?vue&type=style&index=0&id=f378a082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378a082",
  null
  
)

export default component.exports